import { render } from "./HeadsUpContent.vue?vue&type=template&id=1ef1d9dc&scoped=true"
const script = {}

import "./HeadsUpContent.vue?vue&type=style&index=0&id=1ef1d9dc&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ef1d9dc"]])

export default __exports__